import React, { Fragment } from "react";
import { metaItConsulting } from "../../../../Utilites";
import MetaTagComponent from "../../../common/Meta/MetaTagComponent";
import ServiceDetailSection from "../../../services/ServiceDetailSection";
import { BarChart3, Cloud, Layers, ListChecks, Lock, Map, Network, RefreshCw, Server, Shield, Target, TrendingUp, Wallet, Zap } from "lucide-react";

const ItConsulting = () => {
  const service = {
    slug: "it-consulting-strategy",
    title: "IT Consulting & Strategy",
    description:
      "Strategic technology consulting to optimize your IT infrastructure and align technology with business goals.",
    shortDescription:
      "Strategic technology consulting to optimize your operations.",
    icon: Zap,
    gradient: "from-yellow-500 to-orange-500",
    features: [
      "Technology Assessment",
      "Digital Transformation",
      "Cloud Migration",
      "Security Consulting",
      "Process Optimization",
      "Change Management",
    ],
    benefits: [
      "Reduced IT Costs",
      "Improved Security",
      "Better Scalability",
      "Strategic Alignment",
    ],
    process: [
      "Current State Analysis",
      "Strategy Development",
      "Roadmap Creation",
      "Implementation Planning",
      "Ongoing Support",
    ],
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop",
  };

  const extension = {
    keyFeatures: [
      {
        name: "Technology Roadmapping",
        description:
          "Develop long-term IT strategies aligned with your business goals",
        icon: Map,
      },
      {
        name: "IT Infrastructure Assessment",
        description: "Comprehensive evaluation of your existing IT environment",
        icon: Server,
      },
      {
        name: "Digital Transformation",
        description:
          "Modernize legacy systems and processes for a future-ready enterprise",
        icon: RefreshCw,
      },
      {
        name: "Cloud Strategy & Migration",
        description:
          "Plan, migrate, and optimize cloud environments for scalability",
        icon: Cloud,
      },
      {
        name: "Cybersecurity & Risk Management",
        description:
          "Protect your systems with tailored security strategies and compliance planning",
        icon: Shield,
      },
      {
        name: "Vendor & Tool Selection",
        description:
          "Unbiased support in choosing the right platforms, tools, and service providers",
        icon: ListChecks,
      },
    ],

    benefits: [
      {
        title: "Aligned IT & Business Goals",
        description:
          "Ensure your IT investments directly support your strategic business objectives",
        icon: Target,
      },
      {
        title: "Reduced Operational Costs",
        description:
          "Optimize IT resources and eliminate inefficiencies across infrastructure",
        icon: Wallet,
      },
      {
        title: "Future-Proof Technology Stack",
        description:
          "Adopt scalable solutions that evolve with your organization",
        icon: TrendingUp,
      },
      {
        title: "Stronger Security Posture",
        description:
          "Minimize risks and meet regulatory compliance standards effectively",
        icon: Lock,
      },
    ],

    process: [
      {
        step: "Discovery & Assessment",
        description:
          "Conduct a full audit of your existing IT environment, processes, and business needs",
        duration: "1–2 Weeks",
      },
      {
        step: "Strategy Development",
        description:
          "Define your IT vision and build a roadmap tailored to business objectives",
        duration: "2–3 Weeks",
      },
      {
        step: "Architecture Design",
        description:
          "Design scalable, secure, and cost-efficient IT infrastructure",
        duration: "2–4 Weeks",
      },
      {
        step: "Implementation Planning",
        description:
          "Create a phased implementation strategy including timelines and risk mitigation",
        duration: "1–2 Weeks",
      },
      {
        step: "Ongoing Advisory & Optimization",
        description:
          "Support continuous improvement, vendor management, and change management",
        duration: "Ongoing",
      },
    ],

    techStack: [
      { name: "Microsoft Azure", icon: Cloud, category: "Cloud Platform" },
      {
        name: "Amazon Web Services (AWS)",
        icon: Cloud,
        category: "Cloud Platform",
      },
      {
        name: "VMware",
        icon: Server,
        category: "Infrastructure Virtualization",
      },
      { name: "Cisco", icon: Network, category: "Networking & Security" },
      { name: "ServiceNow", icon: Layers, category: "ITSM Platform" },
      { name: "Power BI", icon: BarChart3, category: "Analytics & Reporting" },
    ],
  };

  return (
    <Fragment>
      <MetaTagComponent metaDetails={metaItConsulting} />
      <ServiceDetailSection service={service} extension={extension} />
    </Fragment>
  );
};

export default ItConsulting;
